export default __webpack_public_path__ + "static/media/normal.2ba66dd5.svg";